/* eslint-disable */
import { HttpClient, RequestParams } from "./http-client";

export class SiteSettings<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  getInstagramPostsList = (params: RequestParams = {}) =>
    this.request<any, any>({ path: `/SiteSettings/InstagramPosts`, method: "GET", ...params });
}
